$controls-height: 56px;
$controls-overlap-collapsed: 4px; // Controls how much the control bar is overlappping the video when collapsed

.#{$prefix}videoplayer {
  &:focus:not(.#{$prefix}bottom-controls) .#{$prefix}controls,
  &:hover:not(.#{$prefix}bottom-controls) .#{$prefix}controls {
    bottom: 0;
    transition: bottom 0.25s ease-in;
  }

  .#{$prefix}controls {
    background: $videoplayer-controls-background;
    bottom: -$controls-height + $controls-overlap-collapsed;
    display: flex;
    flex-wrap: nowrap;
    height: $controls-height;
    left: 0;
    margin: 0 auto;
    max-width: 100%;
    position: absolute;
    right: 0;
    transition: bottom 0.25s ease-in 2s;
    width: 100%;
    z-index: 1;
    flex-direction: column;
    cursor: default;

    .#{$prefix}progress-bar {
      background: $videoplayer-progress-background;
      flex-grow: 1;
      height: 8px;

      .#{$prefix}progress-bar-description {
        display: none;
      }

      progress {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background-color: $videoplayer-progress-background; // required by IE, Edge & FF
        border: none;
        border-radius: 0;
        color: $videoplayer-progress-color; // required by IE, Edge
        height: 8px;
        padding: 0;
        width: 100%;
        position: absolute;
        cursor: pointer;

        &:focus-visible {
          height: 12px;
          width: calc(100% - 6px);
          outline: 3px solid $videoplayer-controls-background;
          border: 3px solid $videoplayer-progress-bar-button-focus;
          margin-left: 3px;
          margin-right: 3px;
          box-sizing: border-box;
        }
      }

      progress::-webkit-progress-bar {
        background-color: $videoplayer-progress-background;
      }

      progress::-webkit-progress-value {
        background-color: $videoplayer-progress-bar-value-background;
      }

      progress::-moz-progress-bar {
        background-color: $videoplayer-progress-bar-background;
      }

      progress::-ms-fill {
        border-color: currentColor; // remove IE default border-right of value
      }
    }

    .#{$prefix}playback {
      display: flex;
      height: 48px;
      align-items: center;
      gap: 8px;
      padding: 0 8px;
      flex-shrink: 0;

      .#{$prefix}button {
        border: 0;
        color: $videoplayer-progress-bar-icon-color;
        font-size: 1.8em;
        padding: 0;
        transition: 0.5s background;
        min-height: 36px;
        min-width: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        background: $videoplayer-progress-bar-button-background;
        border-radius: 6px;

        eon-ui-icon {
          color: $videoplayer-progress-bar-icon-color;
        }

        &:active,
        &:hover {
          outline: 2px solid $videoplayer-progress-bar-icon-color;
          background: $videoplayer-progress-bar-button-hover-background;
        }

        &:focus-visible {
          outline: 3px solid $videoplayer-progress-bar-button-focus;
          border-radius: 6px;
        }

        @include for-size(tablet-or-larger) {
          &:active,
          &:hover {
            background: $videoplayer-progress-bar-button-hover-background;
          }
        }

        &.#{$prefix}fullscreen {
          .#{$prefix}eon_fullscreen_exit {
            margin-left: -1px;
            padding-top: 2px;
          }
        }
      }

      .#{$prefix}progress-bar-time {
        color: $videoplayer-progress-bar-time-color;
        font-size: 18px;
        font-weight: 400;
        pointer-events: none;
        width: 100%;
        white-space: nowrap;
      }
    }
  }

  &.#{$prefix}is-touch {
    .#{$prefix}playing ~ eon-ui-videoplayer-controls .#{$prefix}controls {
      bottom: -$controls-height + $controls-overlap-collapsed;
    }
  }
}

.#{$prefix}videoplayer.#{$prefix}bottom-controls {
  margin-top: 0;
  outline: none !important;

  .#{$prefix}controls {
    position: static;
  }
}
